import { render, staticRenderFns } from "./TextAttr.vue?vue&type=template&id=5bf9843c&scoped=true&"
import script from "./TextAttr.vue?vue&type=script&lang=js&"
export * from "./TextAttr.vue?vue&type=script&lang=js&"
import style0 from "./TextAttr.vue?vue&type=style&index=0&id=5bf9843c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9843c",
  null
  
)

export default component.exports